import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { SCOPE_CHAPTERS } from "../content";
import { EASE, Reveal } from "../motion";
import { Section, Wrap, SectionHead } from "./Section";

export default function Scope() {
  const [open, setOpen] = useState(0);

  return (
    <Section id="scope" theme="charcoal" className="py-16 sm:py-24">
      <Wrap>
        <SectionHead
          light
          eyebrow="Scope of the first release"
          title="Four chapters. One coherent first release."
          intro="The final number of service pages, profiles and resources is confirmed during discovery and content planning. The shape below is the commitment."
        />

        <div className="mt-10 sm:mt-12 border-t border-[#F5F3EE]/10" data-testid="scope-chapters">
          {SCOPE_CHAPTERS.map((c, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={c.num} delay={i * 0.4}>
                <div className="border-b border-[#F5F3EE]/10">
                  <button
                    data-testid={`scope-chapter-${i + 1}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center gap-6 sm:gap-10 py-7 text-left cursor-pointer group"
                  >
                    <span className={`font-serif italic text-xl sm:text-2xl transition-colors duration-400 ${isOpen ? "text-[#FFD400]" : "text-[#F5F3EE]/35 group-hover:text-[#F5F3EE]/60"}`}>
                      {c.num}
                    </span>
                    <span className="flex-1">
                      <span className={`block font-serif text-2xl sm:text-3xl font-light transition-colors duration-400 ${isOpen ? "text-[#F5F3EE]" : "text-[#F5F3EE]/75 group-hover:text-[#F5F3EE]"}`}>
                        {c.title}
                      </span>
                      <span className="block text-xs sm:text-sm text-[#F5F3EE]/45 mt-1.5">{c.intro}</span>
                    </span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.4, ease: EASE }}
                      className={`shrink-0 w-10 h-10 rounded-full border flex items-center justify-center transition-[border-color,color] duration-400 ${
                        isOpen ? "border-[#FFD400] text-[#FFD400]" : "border-[#F5F3EE]/25 text-[#F5F3EE]/50"
                      }`}
                    >
                      <Plus size={16} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: EASE }}
                        className="overflow-hidden"
                      >
                        <ul className="pb-10 pl-14 sm:pl-[4.75rem] pr-4 grid sm:grid-cols-2 gap-x-10 gap-y-3 max-w-3xl" data-testid={`scope-chapter-${i + 1}-content`}>
                          {c.items.map((item) => (
                            <li key={item} className="flex items-start gap-3 text-sm text-[#F5F3EE]/75">
                              <span className="w-1.5 h-1.5 rounded-full bg-[#FFD400] mt-1.5 shrink-0" />
                              {item}
                            </li>
                          ))}
                        </ul>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Wrap>
    </Section>
  );
}
